// [Proposition: timeline-taches] Day arithmetic and date labels for the
// timeline and its change log, in the interface language ("30 oct." /
// "30 oct. 2026"). Days are whole UTC days since the epoch, from 'YYYY-MM-DD'.

type TFn = (key: string, params?: Record<string, string | number>) => string;

export const MONTH_KEYS = [
  'calendar.month.jan', 'calendar.month.feb', 'calendar.month.mar', 'calendar.month.apr',
  'calendar.month.may', 'calendar.month.jun', 'calendar.month.jul', 'calendar.month.aug',
  'calendar.month.sep', 'calendar.month.oct', 'calendar.month.nov', 'calendar.month.dec',
];

const MS_DAY = 86_400_000;

export function dayNum(ymd: string): number {
  const [y, m, d] = ymd.slice(0, 10).split('-').map(Number);
  return Math.floor(Date.UTC(y, m - 1, d) / MS_DAY);
}

export function localYmd(d: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** A planned slot (ISO timestamp) as its local calendar day. */
export const plannedDay = (iso: string) => localYmd(new Date(iso));
/** A due date ('YYYY-MM-DD…') as its day. */
export const dueDay = (v: string) => v.slice(0, 10);
export const dateOfDay = (n: number) => new Date(n * MS_DAY);

/** "30 oct." */
export function shortDay(n: number, t: TFn): string {
  const d = dateOfDay(n);
  return `${d.getUTCDate()} ${t(MONTH_KEYS[d.getUTCMonth()])}`;
}

/** "30 oct. 2026" from 'YYYY-MM-DD' (or an ISO timestamp, taken as its local day). */
export function fullDay(value: string, t: TFn): string {
  const ymd = /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : localYmd(new Date(value));
  const n = dayNum(ymd);
  return `${shortDay(n, t)} ${dateOfDay(n).getUTCFullYear()}`;
}

/** A planned slot: "19 oct. 2026", plus " · 09:00" when it has a time. */
export function plannedLabel(iso: string, t: TFn): string {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  const time = d.getHours() || d.getMinutes() ? ` · ${pad(d.getHours())}:${pad(d.getMinutes())}` : '';
  return fullDay(iso, t) + time;
}
